module.exports = __webpack_public_path__ + "src/assets/img/app-store.f5712f78.svg";